require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/core-js/modules/es7.symbol.observable.js
// module id = 834
// module chunks = 20